import React, { useState } from 'react';

import { Box, Button, Group, Stack, Text, Title, useMantineTheme } from '@mantine/core';
import { MonthPickerInput } from '@mantine/dates';
import { useDisclosure } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import StaffAutoComplete, {
  StaffAutoCompleteValue,
} from 'components/form-fields/auto-complete-fields/StaffAutoComplete';
import KiloAlert from 'components/KiloAlert';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';
import dayjs from 'dayjs';

import DrawerLogWorkForm from './components/DrawerLogWorkForm';
import WorkHoursTableContainer from './components/WorkHoursTableContainer';

const EMPTY_STAFF: StaffAutoCompleteValue = { staffId: '', label: '', value: '' };

const WorkHours = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();

  const canLogOnBehalf = hasPerm('PayrollMutate');

  const [isDrawerOpen, { open: openDrawer, close: closeDrawer }] = useDisclosure(false);
  const [monthDate, setMonthDate] = useState<Date>(dayjs().toDate());
  const [staffFilter, setStaffFilter] = useState<StaffAutoCompleteValue>(EMPTY_STAFF);

  const year = dayjs(monthDate).year();
  const month = dayjs(monthDate).month() + 1;

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Work Hours
          </Title>
          <Group>
            {canLogOnBehalf && (
              <Box miw={250}>
                <StaffAutoComplete
                  placeholder='Search or Select a Staff Member'
                  value={staffFilter}
                  onChange={value => setStaffFilter(value ?? EMPTY_STAFF)}
                />
              </Box>
            )}
            <MonthPickerInput
              value={monthDate}
              onChange={value => value && setMonthDate(value)}
              valueFormat='MMMM YYYY'
              allowDeselect={false}
            />
            <Button leftIcon={<IconPlus size={theme.fontSizes.md} />} onClick={openDrawer}>
              Log Work
            </Button>
          </Group>
        </Group>
      </PageHeader>
      <Stack p='md' spacing='md' justify='start'>
        <KiloAlert title='Data overview' m={'unset !important'}>
          <Text size='sm'>Shows hours recorded each month. Not a payroll report.</Text>
        </KiloAlert>
        <WorkHoursTableContainer
          year={year}
          month={month}
          staffId={staffFilter.staffId || undefined}
          canLogOnBehalf={canLogOnBehalf}
          onLogWorkClick={openDrawer}
        />
      </Stack>
      <DrawerLogWorkForm opened={isDrawerOpen} onClose={closeDrawer} />
    </>
  );
};

export default WorkHours;
